// Test different EmailJS template parameter combinations
import emailjs from '@emailjs/browser';

export async function testEmailTemplateParams(testEmail) {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  // Initialize EmailJS
  emailjs.init(publicKey);

  // Try different parameter combinations
  const paramSets = [
    // Standard EmailJS format
    {
      name: 'Standard Format',
      params: {
        user_name: 'Test User',
        user_email: testEmail,
        message: 'Test booking confirmation'
      }
    },
    // Booking specific format 1
    {
      name: 'Booking Format 1',
      params: {
        to_name: 'Test User',
        to_email: testEmail,
        booking_id: 'TEST123',
        message: 'Your booking is confirmed'
      }
    },
    // Booking specific format 2
    {
      name: 'Booking Format 2',
      params: {
        guest_name: 'Test User',
        guest_email: testEmail,
        booking_id: 'TEST123',
        check_in: 'Aug 26, 2025',
        check_out: 'Aug 28, 2025'
      }
    },
    // Simple format
    {
      name: 'Simple Format',
      params: {
        name: 'Test User',
        email: testEmail,
        subject: 'Booking Confirmation',
        message: 'Test message'
      }
    }
  ];

  const results = [];

  for (const paramSet of paramSets) {
    try {
      console.log(`🧪 Testing ${paramSet.name}:`, paramSet.params);
      
      const response = await emailjs.send(serviceId, templateId, paramSet.params);
      
      results.push({
        name: paramSet.name,
        success: true,
        response: response
      });
      
      console.log(`✅ ${paramSet.name} succeeded:`, response);
      break; // Stop on first success
      
    } catch (error) {
      results.push({
        name: paramSet.name,
        success: false,
        error: error.message || error.text
      });
      
      console.log(`❌ ${paramSet.name} failed:`, error.message || error.text);
    }
  }

  return results;
}
